import { useLingui } from '@lingui/react'
import classNames from 'clsx'
import { useCallback, useEffect, type VFC } from 'react'
import { useDispatch, useStore } from 'react-redux'

import {
  TENANT_AT,
  TENANT_BE,
  TENANT_CH,
  TENANT_COM,
  TENANT_FR,
  TENANT_IT,
  TYPE_CART_CSW_THREE_PRODUCTS,
} from 'shared/consts'
import { updateCartShippingBoxMountedAction } from 'shared/store/ducks/cart/actions'
import {
  CHARGE_SEARCH_PARAMS,
  INIT_CROSSSELL,
  INIT_SLIDER,
} from 'shared/store/ducks/events'
import { getProductIdsFromCart } from 'shared/utils/cart'
import AsyncDataFetcher from 'views/components/molecules/AsyncDataFetcher'
import CrosssellWideSkeleton from 'views/components/organisms/CrosssellWideSkeleton'
import { usePublicConfig } from 'views/utils/shopAndRuntimeConfigUtils'

import './CswWithHydration.scss'

const CswWithHydration: VFC<{
  isFreeShipping: boolean
}> = ({ isFreeShipping }) => {
  const store = useStore()
  const {
    tenant,
    crosssell: { widgets },
  } = usePublicConfig()
  const { i18n } = useLingui()
  // dispatch isMounted to store
  const dispatch = useDispatch()
  const pid = getProductIdsFromCart(store.getState().cart.data).join()
  const handleCartShippingBoxUnmountedMountStatus = useCallback(
    (status: boolean) => {
      dispatch(updateCartShippingBoxMountedAction(status))
    },
    [dispatch]
  )

  const addressBoxUnmounted = store.getState().cart.addressBoxUnmounted

  useEffect(() => {
    return () => {
      handleCartShippingBoxUnmountedMountStatus(true)
    }
  }, [handleCartShippingBoxUnmountedMountStatus])

  if (addressBoxUnmounted) {
    return null
  }

  const wrapperClassnames = classNames('o-CrosssellWideWrapper', {
    'u-margin--top@small-tiny':
      tenant === TENANT_FR || tenant === TENANT_IT || tenant === TENANT_BE,
    'a-box u-margin-x-large--ends':
      tenant === TENANT_CH || tenant === TENANT_AT || tenant === TENANT_COM,
    'u-hidden': isFreeShipping,
  })
  return (
    <div className={wrapperClassnames}>
      <AsyncDataFetcher
        api="fock"
        apiCall="fetchCrossSell"
        callOnTopic={'CART_SPA_MOUNTED'}
        callOptions={{
          path: '/crosssell/sliderWide',
          params: {
            wid: widgets[TYPE_CART_CSW_THREE_PRODUCTS],
            title: i18n._('general.crosssell.threeProductsHeader'),
            pid,
          },
        }}
        publishTopic={[INIT_SLIDER, CHARGE_SEARCH_PARAMS, INIT_CROSSSELL]}
        autofetch
        lazyLoad
        className="u-margin--bottom@medium"
      >
        <CrosssellWideSkeleton />
      </AsyncDataFetcher>
    </div>
  )
}

export default CswWithHydration
